import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        <li>
          <Link to="/" className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-home-4-line"></i>
            <span className="ml-1">首页</span>
          </Link>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const catInfo = categories.find((c) => c.name === item.label);

          return (
            <li key={index} className="flex items-center gap-1">
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              {isLast ? (
                <span className="text-foreground-700 font-medium whitespace-nowrap">{item.label}</span>
              ) : item.href ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {catInfo ? (
                    <>
                      <i className={`${catInfo.icon} mr-1`}></i>
                      {item.label}
                    </>
                  ) : (
                    item.label
                  )}
                </Link>
              ) : (
                <span className="text-foreground-500 whitespace-nowrap">{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}